<template>
  <slot></slot>
</template>

<script setup>
import { onMounted, provide, ref, watch } from "vue";
import pako from "pako";

const props = defineProps({
  url: {
    type: String,
    required: true,
  },
});

const loading = ref(false);
const jobCategoryRows = ref([]);

provide("livingWageGapCalculationJobCategoryRowsLoading", loading);
provide("livingWageGapCalculationJobCategoryRows", jobCategoryRows);

async function loadJobCategoryRows() {
  if (!props.url) {
    loading.value = false;
    jobCategoryRows.value = [];
    return;
  }

  loading.value = true;

  const response = await fetch(props.url);
  if (!response.ok) {
    jobCategoryRows.value = [];
    loading.value = false;
    return;
  }

  const buffer = await response.arrayBuffer();
  const jsonText = pako.ungzip(new Uint8Array(buffer), { to: "string" });
  const parsedRows = JSON.parse(jsonText);

  jobCategoryRows.value = Array.isArray(parsedRows) ? parsedRows : [];
  loading.value = false;
}

function handleLoadError(error) {
  loading.value = false;
  jobCategoryRows.value = [];

  console.error(
    "[LivingWageGapCalculationJobCategoryRowsLoader] Failed to load data",
    error,
  );
}

onMounted(() => {
  loadJobCategoryRows().catch(handleLoadError);
});

watch(
  () => props.url,
  () => {
    loadJobCategoryRows().catch(handleLoadError);
  },
);
</script>
